import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import { GlobalService } from 'src/app/service/global.service';
import { PharmacieService } from 'src/app/service/pharmacie.service';

/**
 * HttpInterceptorCAS est utilisé dans le but de rediriger la pharmacie si elle n'est pas authentifiée
 */
@Injectable()
export class HttpInterceptorCAS implements HttpInterceptor {

  constructor(
    protected globalService: GlobalService,
    private pharmacieService: PharmacieService
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        console.log(error);

        if (error.error.url !== null && error.status === 403) {
          window.location.href = error.error.url;
        }

        if (error.url !== null && error.status === 200 && (this.globalService.pharmacie === undefined || this.pharmacieService.wantLogout || !error.ok)) {
          window.location.href = error.url;
        }
        return throwError(error);
      }));
  }
}
